import type { CardProps } from "../../pages/laboratory/components/Cards/components/Card";

export const tarjetas: CardProps[] = [
  {
    image: "/img/laboratory/ourWork/tarjeta1.png",
    subtitle: "solar_tit",
    text: "solar_desc",
    link: "#modal1",
    category: "act_public",
    modalContent: {
      title: "solar_tit_pub",
      description: "solar_desc_pub",
      media: [{ type: "video", src: "/videos/modal1.mp4", alt: "Sistema hidropónico video" }],
    },
  },
  {
    image: "/img/laboratory/ourWork/tarjeta2.png",
    subtitle: "manglar_tit",
    text: "manglar_desc",
    link: "#modal2",
    category: "act_public",
    modalContent: {
      title: "manglar_tit_pub",
      description: "manglar_desc_pub",
      media: [
        { type: "image", src: "/img/laboratory/ourWork/modal2.jpg", alt: "Manglares proyecto" },
        { type: "video", src: "/videos/modal2.mp4", alt: "Manglares video" },
        { type: "pdf", src: "pdf/modal2.pdf", alt: "Manglares documento" },
      ],
    },
  },
  {
    image: "/img/laboratory/ourWork/tarjeta3.png",
    subtitle: "granja_tit",
    text: "granja_desc",
    link: "#modal3",
    category: "linea_inv",
    modalContent: {
      title: "granja_tit_pub",
      description: "granja_desc_pub",
      media: [
        { type: "image", src: "/img/laboratory/ourWork/modal3.png", alt: "FPGA proyecto" },
        { type: "video", src: "/videos/modal3.mp4", alt: "FPGA video" },
        { type: "pdf", src: "/pdf/modal3.pdf", alt: "FPGA documento" },
      ],
    },
  },
  {
    image: "/img/laboratory/ourWork/tarjeta4.png",
    subtitle: "discap_tit",
    text: "discap_desc",
    link: "#modal4",
    category: "act_public",
    modalContent: {
      title: "discap_tit_pub",
      description: "discap_desc_pub",
      media: [
        { type: "image", src: "/img/laboratory/ourWork/modal4.png", alt: "Guante robótico proyecto" },
        { type: "pdf", src: "/pdf/modal4.pdf", alt: "Guante robótico documento" },
      ],
    },
  },
  {
    image: "/img/laboratory/ourWork/tarjeta5.png",
    subtitle: "materiales_tit",
    text: "materiales_desc",
    link: "#modal5",
    category: "linea_inv",
    modalContent: {
      title: "materiales_tit_pub",
      description: "materiales_desc_pub",
      media: [
        { type: "image", src: "/img/laboratory/ourWork/modal5.png", alt: "Materiales compuestos proyecto" },
        { type: "pdf", src: "/pdf/modal5.pdf", alt: "Materiales compuestos documento" },
      ],
    },
  },
];